import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { gsap } from 'gsap';
import { md, lg, xl, wide, xwide } from '../common';

export function initBlockMixedCards(parent) {
  if (!parent) return;

  const swiper = parent.querySelector('.block-mixed-cards__carousel');
  if (swiper) {
    const paginationEl = parent.querySelector('.swiper-pagination');
    new Swiper(swiper, {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        [md]: { slidesPerView: 2, spaceBetween: 20 },
        [lg]: { slidesPerView: 3, spaceBetween: 20 },
        [wide]: { slidesPerView: 3, spaceBetween: 24 },
        [xwide]: { slidesPerView: 3, spaceBetween: 32 },
      },
    });
  }

  const cards = parent.querySelectorAll('.block-mixed-cards__item');
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });
    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initAllBlockMixedCards() {
  const blocks = document.querySelectorAll('.js-block-mixed-cards');
  blocks.forEach((block) => initBlockMixedCards(block));
}
